import { render, staticRenderFns } from "./ImageEditorError.vue?vue&type=template&id=54b4c6d0"
import script from "./ImageEditorError.vue?vue&type=script&lang=ts"
export * from "./ImageEditorError.vue?vue&type=script&lang=ts"
import style0 from "./ImageEditorError.vue?vue&type=style&index=0&id=54b4c6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports